<template>
    <div class="row">
        <div class="col-lg-12" v-if="error">
            <div class="alert alert-danger alert-dismissible fade show" role="alert">
                {{ error }}
                <button type="button" class="close" data-dismiss="alert" aria-label="Close"></button>
            </div>
        </div>
        <div :class="classCtnInput">
            <div class="form-group">
                <el-select
                    v-model="datas"
                    :multiple="multiple"
                    :filterable="filterable"
                    :allow-create="allowCreate"
                    placeholder="Entrez un mot-clé">
                    <el-option
                        v-for="item in list"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <input type="hidden" :value="inputValue" :name="name">
                <!-- <input type="hidden" v-model="allergenes_ids_string" name="allergene"> -->
                <!-- truc : {{ value }} -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            datas: [],
            list: [],
        }
    },
    props: {
        error: {
            default: null
        },
        value:{
            default: null
        },
        name:{
            required: true,
        },
        url:{
            required: true
        },
        filterable:{
            default: true
        },
        multiple:{
            default: true
        },
        allowCreate:{
            default: false
        },
        classCtnInput:{
            default: 'col-lg-6'
        }
    },
    computed: {
        inputValue() {
            return this.multiple ? this.datas.join(',') : this.datas
        }
    },
    mounted(){
        axios.get(this.url).then((r)=>{
            this.list = r.data.data
            if( this.value ) {
                if( !this.multiple ) {
                    this.datas = this.value
                } else {
                    var ids = this.value.split(',')
                    ids.forEach((id) => {
                        this.datas.push(parseInt(id))
                    })
                }
            }
        }).catch((e)=>{
            console.error(e)
        }).then(()=>{
        })

    },
    methods: {

    }
}
</script>
<style lang="scss">
    .el-select{
        width: 100%;
    }
</style>


